import React from 'react';
import '../assets/css/menubar.css';

export const MenuBar = () => {
  return (
    <div className="menubar">
      <a href="#PRE"></a>
      <a href="#PAR"></a>
      <a href="#POR"></a>
      <a href="#CON"></a>

      {/*
			<Link to="#presentation">PS</Link>
			<Link to="#parcours">PC</Link>
			<Link to="#portefolio">PF</Link>
			<Link to="#contactez-moi">CM</Link>*/}
    </div>
  );
};
